import { render, staticRenderFns } from "./TimeSpan.vue?vue&type=template&id=773a5b52"
import script from "./TimeSpan.vue?vue&type=script&lang=js"
export * from "./TimeSpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports